import AddProgramCategory from "../../Components/Modals/AddProgramCategory";
import Table from "../../Components/Table";
import { deleteProgramCategoryById, getAllProgramCategory } from "../../Services/MasterService";

const ProgramCategory = () => {
  const columns = [
    {
      label: "Name",
      value: "name"
    }
  ];

  const renderAddModal = (openAddModal, setOpenAddModal) => {
    return (
      <AddProgramCategory data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
    )
  };

  return (
    <Table
      api={getAllProgramCategory}
      columns={columns}
      title={"Program Category"}
      addModal={renderAddModal}
      showAddButton={true}
      showExportButton={true}
      deleteApi={deleteProgramCategoryById}
    />
  );
}

export default ProgramCategory;